<template>
	<b-container fluid class="mb-5">
		<b-row>
			<b-col cols="10" offset="1">
				<p><router-link to="/">Back to Home</router-link></p>
				<b-img src="images/importer/importer-banner.jpg" class="w-50 mx-auto d-block"></b-img>

				<h3 class="mt-4 text-center" style="line-height:1.5em">
					The Character Importer is a Unity asset that allows you to import your own character models into the game.
				</h3>

				<b-button variant="success" size="lg" class="mt-4 mb-5" to="importer-download">Download</b-button>

				<h2 class="mt-2" style="line-height:1.5em">
					Tutorials
				</h2>

				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'Installation'}}">Installation</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'RigRequirements'}}">Rig Requirements</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'ModelExportAndImport'}}">Model Export and Import</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'BasicInfoModule'}}">Module: Basic Info</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'LimbSetupModule'}}">Module: Limb Setup</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'HandAndFingerModule'}}">Module: Hand and Finger Setup</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'MaterialsAndTexturesModule'}}">Module: Materials and Textures</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'ConfigurablePartsModule'}}">Module: Configurable Parts</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'CollidersModule'}}">Module: Colliders</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'ExpressionsModule'}}">Module: Expressions</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'TailModule'}}">Module: Tail</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'CockModule'}}">Module: Cock</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'PenetrablesModule'}}">Module: Penetrables</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'TouchTargetsModule'}}">Module: Touch Targets</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'EquipmentModule'}}">Module: Equipment</router-link></p>
				<p><router-link :to="{name: 'tutorials', params: {tutorialName: 'SoftbodyModule'}}">Module: Softbody</router-link></p>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	name: 'CharacterImporter',
}
</script>

<style scoped>
</style>
